import { defineMessage } from 'react-intl';

export const placeholderI18n = {
  globalSearch: defineMessage({
    id: 'placeholder.global-search',
    defaultMessage: 'What do you want to learn?'
  })
};
